import React from "react";
import PropTypes from "prop-types";

export const TasksIcon = ({height = "20", width = "20"} = {}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.69007 3.44939C8.88361 3.64636 8.88081 3.96293 8.68383 4.15647L4.94452 7.83034C4.75 8.02146 4.43821 8.02146 4.24368 7.83034L2.14966 5.77297C1.95268 5.57944 1.94989 5.26287 2.14342 5.06589C2.33695 4.86891 2.65352 4.86612 2.8505 5.05965L4.5941 6.77274L7.983 3.44314C8.17997 3.24961 8.49654 3.25241 8.69007 3.44939ZM11.6667 6.16647C11.3906 6.16647 11.1667 6.39033 11.1667 6.66647C11.1667 6.94262 11.3906 7.16647 11.6667 7.16647H18.3334C18.6096 7.16647 18.8334 6.94262 18.8334 6.66647C18.8334 6.39033 18.6096 6.16647 18.3334 6.16647H11.6667ZM11.6667 13.6665C11.3906 13.6665 11.1667 13.8903 11.1667 14.1665C11.1667 14.4426 11.3906 14.6665 11.6667 14.6665H18.3334C18.6096 14.6665 18.8334 14.4426 18.8334 14.1665C18.8334 13.8903 18.6096 13.6665 18.3334 13.6665H11.6667ZM7.33341 14.1665C7.33341 15.4551 6.28875 16.4998 5.00008 16.4998C3.71142 16.4998 2.66675 15.4551 2.66675 14.1665C2.66675 12.8778 3.71142 11.8331 5.00008 11.8331C6.28875 11.8331 7.33341 12.8778 7.33341 14.1665ZM8.33341 14.1665C8.33341 16.0074 6.84103 17.4998 5.00008 17.4998C3.15913 17.4998 1.66675 16.0074 1.66675 14.1665C1.66675 12.3255 3.15913 10.8331 5.00008 10.8331C6.84103 10.8331 8.33341 12.3255 8.33341 14.1665Z"
      fill="currentColor"
    />
  </svg>
);

TasksIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
